import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { AppModule } from './app/app.module';

// Keep production change detection enabled for every dashboard build.
enableProdMode();

document.addEventListener('DOMContentLoaded', () => {
  platformBrowser().bootstrapModule(AppModule)
    .catch(err => console.error(err));
});